// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2EIFL","content":"LayoutSettings_content__2td-_"};